export default {
  PlayerHighlight: true,
  HubPages: true,
  MatchdayTakeover: false,
  TempSocialFeed: false,
  WhereToStream: false,
  PlayerProfileStats: false
}
